export const blogConstants = {
  BLOG_REQUEST: "BLOG_REQUEST",
  BLOG_SUCCESS: "BLOG_SUCCESS",
  BLOG_FAILURE: "BLOG_FAILURE",

  FEATURED_BLOG_REQUEST: "FEATURED_BLOG_REQUEST",
  FEATURED_BLOG_SUCCESS: "FEATURED_BLOG_SUCCESS",
  FEATURED_BLOG_FAILURE: "FEATURED_BLOG_FAILURE",

  BLOG_DETAILS_REQUEST: "BLOG_DETAILS_REQUEST",
  BLOG_DETAILS_SUCCESS: "BLOG_DETAILS_SUCCESS",
  BLOG_DETAILS_FAILURE: "BLOG_DETAILS_FAILURE",

  RESET_FEATURED_BLOG_REQUEST: "RESET_FEATURED_BLOG_REQUEST",
  CUSTOMER_BLOG_REQUEST:"CUSTOMER_BLOG_REQUEST",
  CUSTOMER_BLOG_SUCCESS:"CUSTOMER_BLOG_SUCCESS",
  CUSTOMER_BLOG_FAILURE:"CUSTOMER_BLOG_FAILURE",
};
